import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";

import { X_CART_TYPE } from "@checkout-core/constants/MROCart";
import { GlobalHeaderState } from "@checkout-core/utils/Headers";

/**
 * Whether the current checkout session is an MRO/AIP multi-restaurant cart,
 * based on the x-cart-type header. Shared by cart and payment.
 */
export const isMROFlow = (): boolean => {
    const xCartType = (GlobalHeaderState.getHeader(SwgyHeaderKeysList.xCartType) || "").toLowerCase();
    return [X_CART_TYPE.AIP, X_CART_TYPE.MRO].includes(xCartType as X_CART_TYPE);
};
